import React from "react";
import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { ContractUtilities } from "../../../Utilities";
import styles from "./styles.module.css";

export type ContractPaymentProgressBarProps = {
	paymentProgress: ContractUtilities.PaymentProgressInformation;
} & Partial<ClassNameProps & StyleProps>;

export function ContractPaymentProgressBar({ paymentProgress, className, style }: ContractPaymentProgressBarProps) {
	const { totalPrice, amountPaid, amountDue, amountOverdue } = paymentProgress;

	return (
		<div className={makeClassName(styles["payment-progress"], className)}>
			<div
				className={styles["payment-progress__bar"]}
				style={{ "--total-value": totalPrice, ...style } as React.CSSProperties}
			>
				<div
					className={makeClassName(
						styles["payment-progress__bar__section"],
						styles["payment-progress__bar__section--paid"],
						amountPaid === 0 ? styles["payment-progress__bar__section--empty"] : "",
					)}
					style={{ "--value": amountPaid } as React.CSSProperties}
				></div>
				<div
					className={makeClassName(
						styles["payment-progress__bar__section"],
						styles["payment-progress__bar__section--overdue"],
						amountOverdue === 0 ? styles["payment-progress__bar__section--empty"] : "",
					)}
					style={{ "--value": amountPaid + amountOverdue } as React.CSSProperties}
				></div>
				<div
					className={makeClassName(
						styles["payment-progress__bar__section"],
						styles["payment-progress__bar__section--due"],
						amountDue === 0 ? styles["payment-progress__bar__section--empty"] : "",
					)}
					style={{ "--value": amountPaid + amountOverdue + amountDue } as React.CSSProperties}
				></div>
			</div>
		</div>
	);
}
